import React from "react";

import { useTranslation } from "utils";

import { Flex, Icon, Typography } from "components";

export const SoilPlus3ImpactPanelErrorView = () => {
  const { t } = useTranslation(["fieldTimeline"]);

  return (
    <div data-testid="field-timeline-result-card-error" className="field-timeline-result-card margin-top-200">
      <div className="field-timeline-result-card container">
        <Flex vertical={true} align="center" justify="center" style={{ height: "100%", padding: "2rem 1rem", minHeight: "15rem" }}>
          <Icon dataTestId="field-timeline-result-card-error-icon" className="margin-bottom-200" iconName="tabler/info-circle" size="xl" />
          <Typography
            variant="h5"
            data-testid="field-timeline-result-card-error-title"
            className="margin-bottom-100"
            style={{ textAlign: "center", fontWeight: 600 }}
          >
            {t("impactPanel.errorTitleResultsCurrentlyUnavailable")}
          </Typography>
          <Typography
            variant="paragraph-m"
            data-testid="field-timeline-result-card-error-description"
            className="margin-bottom-150"
            style={{ textAlign: "center", maxWidth: "25rem" }} // 400px
          >
            {t("impactPanel.errorDescriptionResultsCurrentlyUnavailable")}
          </Typography>
          <Typography variant="paragraph-m" data-testid="field-timeline-result-card-error-sub-description" style={{ textAlign: "center", maxWidth: "400px" }}>
            {t("impactPanel.errorSubDescriptionResultsCurrentlyUnavailable")}
          </Typography>
        </Flex>
      </div>
    </div>
  );
};
